/**
 * **Wer einreiht, will hochladen** (ADR 0017).
 *
 * Ein Eintrag in der **Sync-Warteschlange** ist die Änderung UND ihre
 * Ankündigung. `queueSyncChange` ruft hier hinein, `sync-engine` hängt
 * `scheduleSync` daran — und keine Schreibstelle muss mehr daran denken.
 *
 * **Warum ein eigenes Modul und kein direkter Import:** `sync-engine.ts`
 * importiert `db` aus `lib/db/indexeddb.ts`. Ein Gegenimport wäre zirkulär.
 * Diese Datei importiert deshalb NICHTS — sie ist ein Blatt, das beide Seiten
 * gefahrlos ziehen können.
 */

type SyncNotifier = () => void

let notifier: SyncNotifier | null = null

/**
 * Hängt den Melder ein. `sync-engine` tut das beim Laden; Tests setzen `null`,
 * um wieder abzuräumen.
 *
 * **Warum es nicht darauf ankommt, WANN das passiert:** Seit die Schreibstellen
 * `scheduleSync` nicht mehr selbst rufen, lädt nur noch der `SyncProvider` die
 * Engine. Läuft der nicht, ist aber auch `isSyncActive` nie gesetzt — und dann
 * wäre `scheduleSync` ohnehin ein No-Op. Es gibt also keinen erreichbaren
 * Zustand, in dem der Melder fehlt UND gefehlt hätte.
 */
export function setSyncNotifier(next: SyncNotifier | null): void {
  notifier = next
}

/**
 * „Es liegt etwas in der Warteschlange."
 *
 * Schluckt Fehler: Ein Schreibvorgang darf nie daran scheitern, dass der Sync
 * sich verschluckt — die Zeile ist dann lokal längst geschrieben, und der
 * nächste Zyklus findet den Eintrag ohnehin.
 */
export function notifySyncQueued(): void {
  try {
    notifier?.()
  } catch (error) {
    console.warn('[Sync] Melder hat geworfen:', error)
  }
}
